module.exports = __webpack_public_path__ + "static/media/linkedin.9e36c8fd.svg";